﻿let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
import React, { useState, useEffect, useRef } from 'react';

import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

import {


  View,
  Text,
  TextInput,
  TouchableOpacity,
  ScrollView,
  ActivityIndicator,
  StyleSheet,
  Dimensions,
  RefreshControl,
  Animated,
  StatusBar,
  Image,
  Linking,
} from 'react-native';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const apiFetch = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${API_BASE}${endpoint}`, {
      headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY },
      ...options,
    });
    if (!response.ok) return { error: true, status: response.status };
    return await response.json();
  } catch (err) { return { error: true, message: err.message }; }
};


// Bulletproof icon imports with fallbacks
const FallbackIcon = ({ name, size = 24, color = '#666', style, ...props }) => (
  <View 
    style={[
      {
        width: size,
        height: size,
        backgroundColor: color,
        borderRadius: size / 2,
        opacity: 0.3
      },
      style
    ]}
    {...props}
  />
);

let Ionicons = FallbackIcon;
let FontAwesome5 = FallbackIcon;
let MaterialIcons = FallbackIcon;

try {
  const iconsModule = require('@expo/vector-icons');
  if (iconsModule) {
    if (iconsModule.Ionicons && typeof iconsModule.Ionicons === 'function') {
      Ionicons = iconsModule.Ionicons;
    }
    if (iconsModule.FontAwesome5 && typeof iconsModule.FontAwesome5 === 'function') {
      FontAwesome5 = iconsModule.FontAwesome5;
    }
    if (iconsModule.MaterialIcons && typeof iconsModule.MaterialIcons === 'function') {
      MaterialIcons = iconsModule.MaterialIcons;
    }
  }
} catch (error) {
  console.warn('@expo/vector-icons not available, using fallback');
}

// Bulletproof linear gradient import
let LinearGradient;
try {
  const gradientModule = require('expo-linear-gradient');
  LinearGradient = gradientModule.LinearGradient;
} catch (error) {
  console.warn('expo-linear-gradient not available, using View fallback');
  LinearGradient = View;
}

// Mock AsyncStorage for environments where it's not available
let AsyncStorage;
try {
  AsyncStorage = require('@react-native-async-storage/async-storage').default;
} catch (error) {
  console.warn('AsyncStorage not available, using mock implementation');
  AsyncStorage = {
    getItem: async (key) => null,
    setItem: async (key, value) => {},
    removeItem: async (key) => {}
  };
}

// Bulletproof service imports with fallbacks - NO DUPLICATE DECLARATIONS
class MockUnifiedService {
  async initialize() { return true; }
  async trackUserActivity() { return { success: true }; }
  async getCourseRecommendations() { return []; }
  async enrollInCourse() { return { success: true }; }
}

class MockDashboardService {
  async initialize() { return true; }
  async logUserActivity() { return { success: true }; }
  async updateLearningProgress() { return { success: true }; }
}

// Import services with fallbacks - SINGLE DECLARATION
let UnifiedService = MockUnifiedService;
let DashboardService = MockDashboardService;

try {
  const unifiedModule = require('../../services/UnifiedIntegrationService');
  if (unifiedModule && unifiedModule.default) {
    UnifiedService = unifiedModule.default;
  } else if (unifiedModule && typeof unifiedModule === 'function') {
    UnifiedService = unifiedModule;
  }
} catch (error) {
  console.warn('UnifiedIntegrationService not available, using mock');
}

try {
  const dashboardModule = require('../../services/DashboardIntegrationService');
  if (dashboardModule && dashboardModule.default) {
    DashboardService = dashboardModule.default;
  } else if (dashboardModule && typeof dashboardModule === 'function') {
    DashboardService = dashboardModule;
  }
} catch (error) {
  console.warn('DashboardIntegrationService not available, using mock');
}

const { width, height } = Dimensions.get('window');

// Mock course data

// Course Card Component
const CourseCard = ({ course, onPress, onEnroll }) => (
  <TouchableOpacity style={styles.courseCard} onPress={() => onPress(course)}>
    <View style={styles.courseImageContainer}>
      <Image 
        source={{ uri: (course.image && typeof course.image=="string" && course.image.startsWith("http")) ? course.image : undefined }} 
        style={styles.courseImage}
        defaultSource={{ uri: 'https://via.placeholder.com/300x200/CCCCCC/666666?text=Course' }}
      />
      {course.discount && (
        <View style={styles.discountBadge}>
          <Text style={styles.discountText}>{course.discount}</Text>
        </View>
      )}
      {course.isRecommended && (
        <View style={styles.recommendedBadge}>
          <Ionicons name="star" size={12} color="#fff" />
          <Text style={styles.recommendedText}>Recommended</Text>
        </View>
      )}
    </View>

    <View style={styles.courseContent}>
      <View style={styles.courseHeader}>
        <Text style={styles.courseTitle} numberOfLines={2}>{course.title}</Text>
        <Text style={styles.courseProvider}>{course.provider}</Text>
      </View>

      <View style={styles.courseInfo}>
        <View style={styles.courseInfoRow}>
          <View style={styles.infoItem}>
            <Ionicons name="time-outline" size={14} color="#666" />
            <Text style={styles.infoText}>{course.duration}</Text>
          </View>
          <View style={styles.infoItem}>
            <Ionicons name="bar-chart-outline" size={14} color="#666" />
            <Text style={styles.infoText}>{course.level}</Text>
          </View>
        </View>

        <View style={styles.courseInfoRow}>
          <View style={styles.infoItem}>
            <Ionicons name="star" size={14} color="#FFD700" />
            <Text style={styles.infoText}>{course.rating}</Text>
          </View>
          <View style={styles.infoItem}>
            <Ionicons name="people-outline" size={14} color="#666" />
            <Text style={styles.infoText}>{course.students.toLocaleString()}</Text>
          </View>
        </View>
      </View>

      <View style={styles.skillTags}>
        {course.skills.slice(0, 3).map((skill, index) => (
          <View key={index} style={styles.skillTag}>
            <Text style={styles.skillTagText}>{skill}</Text>
          </View>
        ))}
      </View>

      <Text style={styles.courseDescription} numberOfLines={2}>
        {course.description}
      </Text>

      <View style={styles.courseFooter}>
        <View style={styles.priceContainer}>
          <Text style={styles.currentPrice}>{course.price}</Text>
          {course.originalPrice && (
            <Text style={styles.originalPrice}>{course.originalPrice}</Text>
          )}
        </View>
        
        <TouchableOpacity 
          style={styles.enrollButton}
          onPress={() => onEnroll(course)}
        >
          <Text style={styles.enrollButtonText}>Enroll</Text>
        </TouchableOpacity>
      </View>
    </View>
  </TouchableOpacity>
);

const SkillsUpgradeCoursesScreen = ({ navigation }) => {
  // State management
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedLevel, setSelectedLevel] = useState('All');

  // Services - USING RENAMED VARIABLES
  const [unifiedService] = useState(() => new UnifiedService());
  const [dashboardService] = useState(() => new DashboardService());

  // Animations
  const fadeAnim = useRef(new Animated.Value(0)).current;

  // Categories and levels
  const categories = ['All', 'Programming', 'Mobile Development', 'Data Science', 'Design', 'Backend Development', 'Cloud Computing'];
  const levels = ['All', 'Beginner', 'Intermediate', 'Advanced'];

  useEffect(() => {
    initializeScreen();
  }, []);

  useEffect(() => {
    filterCourses();
  }, [courses, searchQuery, selectedCategory, selectedLevel]);

  const initializeScreen = async () => {
    try {
      setLoading(true);
      
      // Initialize services
      await Promise.all([
        unifiedService.initialize().catch(e => console.warn('Unified service init failed:', e)),
        dashboardService.initialize().catch(e => console.warn('Dashboard service init failed:', e))
      ]);

      // Load courses
      await loadCourses();
      
      // Track screen view
      try {
        await unifiedService.trackUserActivity('skills_upgrade_courses_viewed');
      } catch (error) {
        console.warn('Failed to track activity:', error);
      }
      
      // Start animations
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 1000,
        useNativeDriver: true,
      }).start();

    } catch (error) {
      console.error('Error initializing SkillsUpgradeCoursesScreen:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadCourses = async () => {
    try {
      // Try to load from AsyncStorage first
      const cachedData = await AsyncStorage.getItem(`professional_${_profUserId}_skillsCourses`);
      
      if (cachedData) {
        const parsedData = JSON.parse(cachedData);
        setCourses(parsedData);
      } else {
        // Use mock data and save to cache
        setCourses(mockCourses);
        await AsyncStorage.setItem(`professional_${_profUserId}_skillsCourses`, JSON.stringify(mockCourses));
      }
    } catch (error) {
      console.error('Error loading courses:', error);
      // Fallback to mock data
      setCourses(mockCourses);
    }
  };

  const filterCourses = () => {
    let filtered = [...courses];

    // Filter by search query
    if (searchQuery.trim()) {
      filtered = filtered.filter(course =>
        String(course.title ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(course.provider ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        course.skills.some(skill => skill.toLowerCase().includes(searchQuery.toLowerCase())) ||
        String(course.description ?? '').toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Filter by category
    if (selectedCategory !== 'All') {
      filtered = filtered.filter(course => course.category === selectedCategory);
    }

    // Filter by level
    if (selectedLevel !== 'All') {
      filtered = filtered.filter(course => course.level === selectedLevel);
    }

    setFilteredCourses(filtered);
  };

  const onRefresh = async () => {
    setRefreshing(true);
    await loadCourses();
    setRefreshing(false);
  };

  const handleBackPress = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate('Dashboard');
    }
  };

  const handleCoursePress = (course) => {
    // Navigate to course details or open course page
    console.log('Course pressed:', course.title);
    // navigation.navigate('CourseDetail', { course });
  };

  const handleEnrollCourse = async (course) => {
    try {
      // Track enrollment activity
      await unifiedService.trackUserActivity('course_enrolled', { courseId: course.id });
      await dashboardService.updateLearningProgress('course_enrolled', { courseId: course.id });

      // Mirror enrollment into ProfileManagementService so it appears in profile/dashboard
      // course-progress sections across the app.
      try {
        await ProfileManagementService.bootstrap();
        await ProfileManagementService.enrollInCourse(course.id);
      } catch (_) {}
      
      // Open course URL or navigate to enrollment
      if (course.url) {
        Linking.openURL(course.url);
      } else {
        // Show enrollment success
        alert(`Successfully enrolled in ${course.title}!`);
      }
    } catch (error) {
      console.error('Error enrolling in course:', error);
      alert('Failed to enroll in course. Please try again.');
    }
  };

  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <StatusBar barStyle="light-content" backgroundColor="#667eea" />
        <ActivityIndicator size={36} color="#4CAF50" />
        <Text style={styles.loadingText}>Loading Courses...</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#667eea" />
      
      {/* Header */}
      <LinearGradient
        colors={['#667eea', '#764ba2']}
        style={styles.header}
      >
        <TouchableOpacity style={styles.backButton} onPress={handleBackPress}>
          <Ionicons name="arrow-back" size={24} color="#fff" />
        </TouchableOpacity>
        
        <Text style={styles.headerTitle}>Skills Upgrade Courses</Text>
        
        <TouchableOpacity 
          style={styles.filterButton}
          onPress={() => {/* Show filter modal */}}
        >
          <Ionicons name="filter" size={24} color="#fff" />
        </TouchableOpacity>
      </LinearGradient>

      {/* Search and Filters */}
      <View style={styles.searchContainer}>
        <View style={styles.searchBar}>
          <Ionicons name="search" size={20} color="#666" />
          <TextInput
            style={styles.searchInput}
            placeholder="Search courses..."
            value={searchQuery}
            onChangeText={setSearchQuery}
          />
          {searchQuery.length > 0 && (
            <TouchableOpacity onPress={() => setSearchQuery('')}>
              <Ionicons name="close-circle" size={20} color="#666" />
            </TouchableOpacity>
          )}
        </View>

        <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.categoryFilter}>
          {categories.map((category) => (
            <TouchableOpacity
              key={category}
              style={[
                styles.categoryChip,
                selectedCategory === category && styles.categoryChipSelected
              ]}
              onPress={() => setSelectedCategory(category)}
            >
              <Text style={[
                styles.categoryChipText,
                selectedCategory === category && styles.categoryChipTextSelected
              ]}>
                {category}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>

        <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.levelFilter}>
          {levels.map((level) => (
            <TouchableOpacity
              key={level}
              style={[
                styles.levelChip,
                selectedLevel === level && styles.levelChipSelected
              ]}
              onPress={() => setSelectedLevel(level)}
            >
              <Text style={[
                styles.levelChipText,
                selectedLevel === level && styles.levelChipTextSelected
              ]}>
                {level}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>

      {/* Results Header */}
      <View style={styles.resultsHeader}>
        <Text style={styles.resultsText}>
          {filteredCourses.length} courses found
        </Text>
        <Text style={styles.resultsSubtext}>
          Recommended courses based on your skills
        </Text>
      </View>

      {/* Courses List */}
      <ScrollView
        style={styles.content}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
        showsVerticalScrollIndicator={false}
      >
        <Animated.View style={[styles.coursesList, { opacity: fadeAnim }]}>
          {filteredCourses.length > 0 ? (
            filteredCourses.map((course) => (
              <CourseCard
                key={course.id}
                course={course}
                onPress={handleCoursePress}
                onEnroll={handleEnrollCourse}
              />
            ))
          ) : (
            <View style={styles.emptyState}>
              <Ionicons name="school-outline" size={64} color="#ccc" />
              <Text style={styles.emptyStateTitle}>No Courses Found</Text>
              <Text style={styles.emptyStateText}>
                {searchQuery 
                  ? `No courses match "${searchQuery}"`
                  : 'Try adjusting your filters to see more courses'
                }
              </Text>
            </View>
          )}
        </Animated.View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#666',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    paddingTop: 50,
  },
  backButton: {
    padding: 8,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#fff',
  },
  filterButton: {
    padding: 8,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  searchContainer: {
    backgroundColor: '#fff',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  searchBar: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f8f9fa',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginBottom: 12,
  },
  searchInput: {
    flex: 1,
    fontSize: 16,
    marginLeft: 12,
    color: '#333',
  },
  categoryFilter: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  categoryChip: {
    backgroundColor: '#f0f0f0',
    borderRadius: 20,
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginRight: 8,
    borderWidth: 1,
    borderColor: '#ddd',
  },
  categoryChipSelected: {
    backgroundColor: '#4CAF50',
    borderColor: '#4CAF50',
  },
  categoryChipText: {
    fontSize: 14,
    color: '#666',
  },
  categoryChipTextSelected: {
    color: '#fff',
    fontWeight: '600',
  },
  levelFilter: {
    flexDirection: 'row',
  },
  levelChip: {
    backgroundColor: '#f0f0f0',
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginRight: 8,
    borderWidth: 1,
    borderColor: '#ddd',
  },
  levelChipSelected: {
    backgroundColor: '#2196F3',
    borderColor: '#2196F3',
  },
  levelChipText: {
    fontSize: 12,
    color: '#666',
  },
  levelChipTextSelected: {
    color: '#fff',
    fontWeight: '600',
  },
  resultsHeader: {
    backgroundColor: '#fff',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  resultsText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
  },
  resultsSubtext: {
    fontSize: 14,
    color: '#666',
    marginTop: 2,
  },
  content: {
    flex: 1,
  },
  coursesList: {
    padding: 20,
  },
  courseCard: {
    backgroundColor: '#fff',
    borderRadius: 16,
    marginBottom: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 5,
    overflow: 'hidden',
  },
  courseImageContainer: {
    position: 'relative',
  },
  courseImage: {
    width: '100%',
    height: 200,
    backgroundColor: '#f0f0f0',
  },
  discountBadge: {
    position: 'absolute',
    top: 12,
    right: 12,
    backgroundColor: '#f44336',
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  discountText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
  },
  recommendedBadge: {
    position: 'absolute',
    top: 12,
    left: 12,
    backgroundColor: '#4CAF50',
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 4,
    flexDirection: 'row',
    alignItems: 'center',
  },
  recommendedText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
    marginLeft: 4,
  },
  courseContent: {
    padding: 16,
  },
  courseHeader: {
    marginBottom: 12,
  },
  courseTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 4,
  },
  courseProvider: {
    fontSize: 14,
    color: '#666',
  },
  courseInfo: {
    marginBottom: 12,
  },
  courseInfoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  infoItem: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  infoText: {
    fontSize: 12,
    color: '#666',
    marginLeft: 4,
  },
  skillTags: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  skillTag: {
    backgroundColor: '#e3f2fd',
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginRight: 6,
    marginBottom: 4,
  },
  skillTagText: {
    fontSize: 11,
    color: '#1976d2',
    fontWeight: '500',
  },
  courseDescription: {
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
    marginBottom: 16,
  },
  courseFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  priceContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  currentPrice: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#4CAF50',
  },
  originalPrice: {
    fontSize: 16,
    color: '#999',
    textDecorationLine: 'line-through',
    marginLeft: 8,
  },
  enrollButton: {
    backgroundColor: '#4CAF50',
    borderRadius: 25,
    paddingHorizontal: 24,
    paddingVertical: 12,
  },
  enrollButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  emptyState: {
    alignItems: 'center',
    padding: 40,
  },
  emptyStateTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#666',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyStateText: {
    fontSize: 14,
    color: '#999',
    textAlign: 'center',
  },
});

export default SkillsUpgradeCoursesScreen;
